import script from "./ContentPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentPreview.vue?vue&type=script&lang=ts&setup=true"

import "./ContentPreview.vue?vue&type=style&index=0&id=5d46f07b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d46f07b"]])

export default __exports__